import type { ChildTypeFilter, LayoutGoalReportParams, LastUsedLayoutParams } from '@data';

import type { Filter } from './hooks/useFetchAllUserActivities';

const USER = 'user';
const USER_SETTINGS = 'user-settings';
const GOAL_REPORT = 'goal-report';
const ACTIVITIES = 'activities';
const SWINGS = 'swings';
const ANALYSIS = 'analysis';

const LAYOUTS = 'layouts';
const ALL = 'all';
const PUBLIC = 'public';
const DEFAULT = 'default';
const CUSTOMIZATIONS = 'customizations';
const LAST_USED = 'last_used';
const COUNT = 'count';
export const queryKeys = {
    user: {
        all: () => [USER] as const,
        base: (userId: string) => [USER, userId] as const,
        settings: (userId: string) => [...queryKeys.user.base(userId), USER_SETTINGS],
    },
    activities: {
        base: () => [...queryKeys.user.all(), ACTIVITIES] as const,
        one: (activityId: number) => [...queryKeys.activities.base(), activityId] as const,
        current: (userId: string) => [...queryKeys.user.base(userId), ACTIVITIES, 'current'] as const,
        paged: (userId: string) => [...queryKeys.user.base(userId), ACTIVITIES, 'paged', 'filters'] as const,
        filtered: (userId: string, filter?: Partial<Filter>) =>
            [...queryKeys.activities.paged(userId), filter] as const,
        count: (userId: string) => [...queryKeys.user.base(userId), ACTIVITIES, COUNT],
    },
    swings: {
        base: (userId: string) => [...queryKeys.user.base(userId), SWINGS] as const,
        analysis: (userId: string, uuid: string) => [...queryKeys.swings.base(userId), uuid, ANALYSIS] as const,
    },

    layout: {
        one: (userId: string, layoutId: number) => [...queryKeys.user.base(userId), LAYOUTS, layoutId] as const,
        base: (userId: string) => [...queryKeys.user.base(userId), LAYOUTS] as const,
        all: (userId: string) => [...queryKeys.layout.base(userId), ALL] as const,
        public: (userId: string) => [...queryKeys.layout.base(userId), PUBLIC] as const,
        default: (userId: string) => [...queryKeys.layout.base(userId), DEFAULT] as const,
        user: (userId: string) => [...queryKeys.layout.base(userId), USER] as const,
        activity: (userId: string, activityId: number) => [...queryKeys.layout.base(userId), activityId] as const,
        lastUsed: (userId: string, lastUsed: LastUsedLayoutParams) =>
            [...queryKeys.layout.base(userId), LAST_USED, lastUsed.clubId, lastUsed.limit] as const,
    },
    goals: {
        reportBase: (userId: string, layoutId: number) =>
            [...queryKeys.layout.one(userId, layoutId), GOAL_REPORT] as const,
        report: (userId: string, layoutId: number, { from, to, lastSwings }: Partial<LayoutGoalReportParams>) =>
            [...queryKeys.goals.reportBase(userId, layoutId), from, to, lastSwings] as const,
    },
    layoutCustomization: {
        base: (userId: string, layoutId: number) => [...queryKeys.layout.base(userId), layoutId] as const,
        key: (userId: string, layoutId: number, childType?: ChildTypeFilter | ChildTypeFilter[]) =>
            [...queryKeys.layoutCustomization.base(userId, layoutId), CUSTOMIZATIONS, childType] as const,
    },
};
